import { useCloseButton } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useCloseButton'
import { useNavigationSeparator } from '@mobile/views/Relation/Shared/Popup/builder/buttons/useNavigationSeparator'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import RunsOffBallPopupDetails from './RunsOffBallPopupDetails.vue'

export const RunsOffBallPopup = new PopupBuilder('Runs off Ball')
  .appendBody(RunsOffBallPopupDetails)
  .setNavigationButtons([
    ...useNavigationSeparator(4),
    useCloseButton({
      color: 'red',
      text: 'Close',
    }),
  ])
  .build()
